export const eventLabels = {
  order_read:"order_read",order_edit:"order_edit",balance_changed:"balance_changed",profile_updated:"profile_updated",cart_items_added:"cart_items_added",cart_selection_updated:"cart_selection_updated",
  login_success:'เข้าสู่ระบบสำเร็จ', login_failed:'เข้าสู่ระบบไม่สำเร็จ', logout:'ออกจากระบบ',
  session_rejected:'ระบบปฏิเสธ session', session_cleared:'Browser ล้าง session',
  session_restore_failed:'Browser ตรวจ session ไม่สำเร็จ', stale_response_ignored:'ละทิ้งผลตอบกลับของ session เก่า',
  permission_denied:'ไม่มีสิทธิ์ทำรายการ', sensitive_read:'อ่าน/ส่งออกข้อมูลสำคัญ',
  impersonation_token_created:'สร้าง token เพื่อช่วยเหลือลูกค้า', api_action:'ทำรายการผ่านระบบ',
  job_finished:'งานอัตโนมัติจบการทำงาน', view_page:'เปิดหน้า', search_query:'ค้นหา',
  click_link:'กดลิงก์', download_requested:'กดส่งออกรายงาน', download_report:'เริ่มส่งออกรายงาน',
};
export const outcomeLabels = {success:'สำเร็จ',failure:'ไม่สำเร็จ',unknown:'ยังระบุผลไม่ได้',reported:'Browser รายงาน',completed:'จบการทำงาน'};
export const evidenceLabels = {server_response:'ผลตอบกลับ API',server_job:'งาน Backend',client_report:'Browser รายงาน'};

export const orderFieldDescriptions = {
  working:'บันทึกผู้เปิดดูออเดอร์',display:'เปลี่ยนการแสดงออเดอร์',
  status:'เปลี่ยนสถานะออเดอร์',totalPrice:'แก้ราคา',totalPrice_lak:'แก้ราคากีบ',
  paymentMethod:'เปลี่ยนวิธีชำระเงิน',paymentChannel:'เปลี่ยนช่องทางชำระเงิน',paidCurrency:'เปลี่ยนสกุลเงิน',
  shippingStatus:'เปลี่ยนสถานะจัดส่ง',shippingTrack:'แก้เลขพัสดุ',shippingDate:'แก้วันที่จัดส่ง',
  deliverChannel:'เปลี่ยนวิธีรับสลาก',expireAt:'แก้เวลาหมดอายุ',changeExpire:'เพิ่มเวลาหมดอายุ',
  slips:'เพิ่มสลิป',slipId:'แก้รหัสสลิป',note:'แก้หมายเหตุ',
};
export const auditMoneyUnits = {totalPrice:' ฿',totalPrice_lak:' กีบ',price:' ฿',shippingPrice:' ฿',discount:' ฿',buyCash:' ฿'};
